import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AuthPage from "@/pages/AuthPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import Dashboard from "@/pages/Dashboard";
import LessonsPage from "@/pages/LessonsPage";
import LessonViewer from "@/pages/LessonViewer";
import PlannerPage from "@/pages/PlannerPage";
import NestPage from "@/pages/NestPage";
import ReportsPage from "@/pages/ReportsPage";
import FamilyPage from "@/pages/FamilyPage";
import ReadingLogPage from "@/pages/ReadingLogPage";
import LegalPage from "@/pages/LegalPage";
import LandingPage from "@/pages/LandingPage";
import PricingPage from "@/pages/PricingPage";
import ContactPage from "@/pages/ContactPage";
import PurchaseConfirmationPage from "@/pages/PurchaseConfirmationPage";
import AdminPage from "@/pages/AdminPage";
import Footer from "@/components/Footer";
import ErrorBoundary from "@/components/ErrorBoundary";
import { Toaster } from "@/components/ui/sonner";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center bg-[#FAF9F6]"><div className="animate-pulse text-[#2D5A46] font-semibold text-lg">Loading...</div></div>;
  if (!user) return <Navigate to="/auth" />;
  return children;
}

function AppRoutes() {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center bg-[#FAF9F6]"><div className="animate-pulse text-[#2D5A46] font-semibold text-lg">Loading...</div></div>;
  return (
    <Routes>
      <Route path="/auth" element={user ? <Navigate to="/dashboard" /> : <AuthPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/" element={<LandingPage />} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/lessons" element={<ProtectedRoute><LessonsPage /></ProtectedRoute>} />
      <Route path="/lessons/:reference" element={<ProtectedRoute><LessonViewer /></ProtectedRoute>} />
      <Route path="/planner" element={<ProtectedRoute><PlannerPage /></ProtectedRoute>} />
      <Route path="/nest" element={<ProtectedRoute><NestPage /></ProtectedRoute>} />
      <Route path="/reports" element={<ProtectedRoute><ReportsPage /></ProtectedRoute>} />
      <Route path="/family" element={<ProtectedRoute><FamilyPage /></ProtectedRoute>} />
      <Route path="/reading-log" element={<ProtectedRoute><ReadingLogPage /></ProtectedRoute>} />
      <Route path="/legal" element={<LegalPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/pricing" element={<PricingPage />} />
      <Route path="/purchase-confirmation" element={<ProtectedRoute><PurchaseConfirmationPage /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute><AdminPage /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        {/* Wraps the routes only: a crash inside a page still leaves the Footer
            and Toaster mounted, and shows the error instead of a white screen. */}
        <ErrorBoundary>
          <AppRoutes />
        </ErrorBoundary>
        <Footer />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
